import React, { Component } from "react";
import CustomPointsDialog from "../../components/structure/CustomPointsDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import moment from "moment-timezone";

class CustomPointsContainer extends Component {
  state = {
    open: false,
    name: "",
    abbr: "",
    showUnderResults: true,
    addPointsToPouleScore: false,
    submitDisabled: true,
    deleteConfirm: false,
    type: "0",
  };

  handleSwitch = () => {
    this.setState({ showUnderResults: !this.state.showUnderResults });
  };

  handleSwitchAddPointsToPouleScore = () => {
    this.setState({ addPointsToPouleScore: !this.state.addPointsToPouleScore });
  };

  toggleDialog = () => {
    if (!this.state.open && this.props.customPoints) {
      this.updateState(this.props.customPoints);
    }
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const customPoints = this.props.customPoints;
    if (customPoints) {
      this.updateState(customPoints);
    }
  };

  updateState = (customPoints) => {
    this.setState({
      name: customPoints.name || "",
      abbr: customPoints.abbr || "",
      showUnderResults: customPoints.showUnderResults,
      addPointsToPouleScore: customPoints.addPointsToPouleScore || false,
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.customPoints) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    this.toggleDialog();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let currentCustomPoints = this.props.tournament.customPoints || {};
    if (this.props.playerStats) {
      currentCustomPoints = this.props.tournament.playerPoints || {};
    }

    if (this.props.customPoints) {
      currentCustomPoints[this.props.customPoints.id]["name"] = this.state.name;
      currentCustomPoints[this.props.customPoints.id]["abbr"] = this.state.abbr;
      currentCustomPoints[this.props.customPoints.id]["showUnderResults"] =
        this.state.showUnderResults;
      currentCustomPoints[this.props.customPoints.id]["addPointsToPouleScore"] =
        this.state.addPointsToPouleScore;
    } else {
      let newId = moment().unix().toString();
      let type = this.state.type;
      if (
        type === "0" &&
        (this.props.tournament.playerPoints || {})["0"] !== undefined
      ) {
        type = "1";
      }
      if (this.props.playerStats && type === "0") {
        newId = "0";
      }

      let name = this.state.name;
      let abbr = this.state.abbr;
      if (this.props.playerStats && type === "3") {
        name = languages.structure.presence;
        abbr = languages.structure.presenceAbbr;
      }
      if (this.props.playerStats && type === "4") {
        name = languages.structure.yellowCards;
        abbr = languages.structure.yellowCardsAbbr;
      }
      if (this.props.playerStats && type === "5") {
        name = languages.structure.redCards;
        abbr = languages.structure.redCardsAbbr;
      }

      currentCustomPoints[newId] = {};
      currentCustomPoints[newId]["name"] = name;
      currentCustomPoints[newId]["abbr"] = abbr;
      currentCustomPoints[newId]["type"] = this.state.type;
      currentCustomPoints[newId]["showUnderResults"] =
        this.state.showUnderResults;
      currentCustomPoints[newId]["addPointsToPouleScore"] =
        this.state.addPointsToPouleScore;
    }

    let toUpdate = {};

    if (this.props.playerStats) {
      toUpdate["playerPoints"] = currentCustomPoints;
    } else {
      toUpdate["customPoints"] = currentCustomPoints;
    }

    tournamentRef
      .update(toUpdate)
      .then(() => {
        if (this.props.customPoints) {
          this.setState({ submitDisabled: true });
        } else {
          this.setState({
            name: "",
            abbr: "",
            showUnderResults: true,
            addPointsToPouleScore: false,
            submitDisabled: true,
          });
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };

  handleDelete = (e) => {
    e.preventDefault();
    if (this.state.deleteConfirm) {
      this.toggleDialog();
      const tournamentRef = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      let current = this.props.tournament.customPoints || {};
      if (this.props.playerStats) {
        current = this.props.tournament.playerPoints || {};
      }
      delete current[this.props.customPoints.id];
      if (this.props.playerStats) {
        tournamentRef.update({ playerPoints: current });
      } else {
        tournamentRef.update({ customPoints: current });
      }
    } else {
      this.setState({ deleteConfirm: true });
    }
  };

  render() {
    let submitDisabled =
      (this.state.name.length === 0 ||
        this.state.abbr.length === 0 ||
        this.state.abbr.length > 3) &&
      this.state.type !== "3" &&
      this.state.type !== "4" &&
      this.state.type !== "5";

    let types = [];
    if (this.props.playerStats && !this.props.customPoints) {
      if ((this.props.tournament.playerPoints || {})["0"] === undefined) {
        types = [{ id: "0", name: languages.structure.playerGoals }];
      }
      if (
        Object.keys(this.props.tournament.playerPoints || {}).find((p) => {
          return this.props.tournament.playerPoints[p].type === "3";
        }) === undefined
      ) {
        types.push({ id: "3", name: languages.structure.presence });
      }
      if (
        Object.keys(this.props.tournament.playerPoints || {}).find((p) => {
          return this.props.tournament.playerPoints[p].type === "4";
        }) === undefined
      ) {
        types.push({ id: "4", name: languages.structure.yellowCards });
      }
      if (
        Object.keys(this.props.tournament.playerPoints || {}).find((p) => {
          return this.props.tournament.playerPoints[p].type === "5";
        }) === undefined
      ) {
        types.push({ id: "5", name: languages.structure.redCards });
      }
      types.push({
        id: "1",
        name:
          languages.structure.inputPlayer + " " + languages.structure.multiple,
      });
      types.push({
        id: "2",
        name:
          languages.structure.inputPlayer + " " + languages.structure.single,
      });
    }

    let type = this.state.type;
    if (
      type === "0" &&
      (this.props.tournament.playerPoints || {})["0"] !== undefined
    ) {
      type = "1";
    }

    return (
      <div>
        {this.props.customPoints ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            disabled={this.props.disabled}
            style={{ height: 30, width: 30 }}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 5 }}
            />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
          >
            {this.props.playerStats
              ? languages.structure.morePointsPlayers
              : languages.structure.morePoints}
          </Button>
        )}
        <CustomPointsDialog
          tournament={this.props.tournament}
          name={this.state.name}
          abbr={this.state.abbr}
          showUnderResults={this.state.showUnderResults}
          submitDisabled={submitDisabled}
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          customPoints={this.props.customPoints}
          handleSwitch={this.handleSwitch}
          handleDelete={this.handleDelete}
          deleteConfirm={this.state.deleteConfirm}
          playerStats={this.props.playerStats}
          types={types}
          type={type}
          addPointsToPouleScore={this.state.addPointsToPouleScore}
          handleSwitchAddPointsToPouleScore={
            this.handleSwitchAddPointsToPouleScore
          }
        />
      </div>
    );
  }
}

export default CustomPointsContainer;
